// extracted by mini-css-extract-plugin
module.exports = {"security-main-details":"security-details_security-main-details__2kxik","section":"security-details_section__nO24E","line":"security-details_line__2_8oP"};